import { VolumeX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSoundArmed } from "./audio";

/** Shown only until the browser lets the panel play sound (first click or key after a load). */
export function SoundLockedHint() {
  const { t } = useTranslation();
  const armed = useSoundArmed();
  if (armed) return null;
  return (
    <span className="flex items-center gap-1 text-amber-400" title={t("alerts.soundLockedHint")}>
      <VolumeX size={14} /> {t("alerts.soundLocked")}
    </span>
  );
}
